import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, SCAMP_API } from 'src/environments/environment';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class LocalService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getLocaisTodos() {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais-todos-cb`, { headers: this.account.composeHeaders() });
    }
    getLocaisNaoPredio() {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais-nao-predio`, { headers: this.account.composeHeaders() });
    }
    // TODO: Elimar serviço predioService e substituir o método getPredio por este onde for usado (avaliar-spv)
    getLocaisPredio() {
        return this.http.get(`${SCAMP_API.accountApiV1}/predios-cb`, { headers: this.account.composeHeaders() });
    }
    setOutroLocalDeTrabalho(dado) {
        return this.http.post(`${SCAMP_API.accountApiV1}/outro-local`, dado, { headers: this.account.composeHeaders() });
    }
    isUniqueNomeLocal(nome) {
        return this.http.get(`${SCAMP_API.accountApiV1}/is-unique-nome-local/${nome}`, { headers: this.account.composeHeaders() });
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/local`, data, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/local/${id}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/local/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/local/${id}`, { headers: this.account.composeHeaders() });
    }
    list() {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais-todos-cb`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais`, { headers: this.account.composeHeaders() });
    }
    listSubstacoes() {
        return this.http.get(`${SCAMP_API.accountApiV1}/substacoes`, { headers: this.account.composeHeaders() });
    }
    isUniqueCodigoSubstacao(codigo) {
        return this.http.get(`${SCAMP_API.accountApiV1}/is-unique-codigo-substacao/${codigo}`, { headers: this.account.composeHeaders() });
    }
    search(parametro, tipoLocal) {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais-search/${parametro}/${tipoLocal}`, { headers: this.account.composeHeaders() });
    }
    getLocaisByGroupLevelOne(grupoLocalNivel1Id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais-by-group-level-one/${APP_SETTINGS.tipoLocal}/${grupoLocalNivel1Id}`, { headers: this.account.composeHeaders() });
    }
    getLocaisByGrupoLocalNivelId(grupolocalid) {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais/por-grupolocalnivelid/${APP_SETTINGS.tipoLocal}/${grupolocalid}`, { headers: this.account.composeHeaders() });
    }
    getNextId() {
        return this.http.get(`${SCAMP_API.accountApiV1}/locais/next-id`, { headers: this.account.composeHeaders() });
    }
}
LocalService.ngInjectableDef = i0.defineInjectable({ factory: function LocalService_Factory() { return new LocalService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: LocalService, providedIn: "root" });
